const myAccount = {
  label1: 'Accesos',
  label2: 'Mi cuenta',
  label3: 'Salir'
}

export default myAccount;
